// import PortfolioDetails from "../assets/new-images/about.png";
import AboutInner from "../assets/new-images/about-inner-1.png";
import UserAdmin from "../assets/new-images/user-icon.png";
import CustomFooter from "../component/Footer/customFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Helmet } from "react-helmet-async";
import HeaderMenu from "../component/Navbar/headermenu";
import { motion } from "framer-motion";
import AboutHero from "./About/AboutHero";
import "../pages/About/about.css";
import WhyWeStarted from "./About/WhyWeStarted";
import WhoWeBuildFor from "./About/WhoWeBuildFor";
import WhatWeBelieve from "./About/WhatWeBelieve";
import FounderSection from "./About/FounderSection";
import BentoFeatures from "./About/BentoFeatures";
import CtaSection from "./About/CtaSection";

const About = () => {
  return (
    <>
      <Helmet>
        {/* <title>About | Simplifyte</title> */}
        <title>Why we built Simplifyte - About</title>

        {/* Open Graph meta */}
        <meta property="og:title" content="About | Simplifyte" />
        <meta
          name="description"
          property="og:description"
          content="Simplifyte is built by the doers, for the doers."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.simplifyte.com/about" />

        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte, about Simplifyte, team Simplifyte, our story, who we are, Simplifyte mission"
        />
      </Helmet>

      <div>
        <HeaderMenu />
        <AboutHero />
        <WhyWeStarted />
        <WhoWeBuildFor />
        <WhatWeBelieve />
        <FounderSection />
        <BentoFeatures />
        <CtaSection />
        {/* <section className="about-page about-page-padding mt-[50px]">
          <div className="container">
            <div className="row-direction">
              <div className="team-width">
                <div className=" text-center">
                  <h1 className="about-main-title mb-50">
                    Simplifyte is built by the doers, for the doers.
                  </h1>
                </div>

                <div className="about-details-content">
                  <div className="row-direction">
                    <div className="direction-columns">
                      <div className="about-title">
                        We’re building the workflow platform for teams that
                        value clarity and speed
                      </div>
                    </div>
                    <div className="direction-columns">
                      <div className="about-details-text mb-35">
                        <p className="content">
                          Computers were supposed to make work easier. But over
                          time, tools became bloated, slow, and chaotic—causing
                          more confusion than clarity. We felt the pain too. So,
                          we set out to build something better: a platform that
                          teams actually enjoy using. We called it{" "}
                          <b>Simplifyte</b> because clarity should become
                          standard in business.
                        </p>
                        <p className="content">
                          What began as a smart task manager evolved into a
                          full-scale workflow system for service professionals.
                          Simplifyte helps teams organize work, manage tasks,
                          track files, and communicate—without mess. We’re not
                          just building another app ,but we’re building a{" "}
                          <b>smarter way to work</b>.
                        </p>
                        <p className="content">
                          Today, teams across industries—from CA firms and legal
                          teams to IT consultancies—use Simplifyte to stay ahead
                          of deadlines and deliver high-quality work. It’s
                          everything your team needs, minus chaos.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="team-section mb-50">
                    <div className="row-direction">
                      <div className="team-width">
                        <p className="team-title">Team</p>
                      </div>

                      <div className="direction-columns">
                        <div className="about-details-text team-div">
                          <h4 className="about-title">
                            We care deeply about what we build — and who we
                            build it for
                          </h4>
                          <p className="team-content">
                            Simplifyte was born from a passion for simplifying
                            complex work. Today, our close-knit team is
                            distributed across India and beyond. What brings us
                            together is a shared commitment to thoughtful
                            design, fast execution, and meaningful impact.
                          </p>
                          <p className="team-content">
                            We’re not just building software — we’re crafting
                            tools that teams trust daily. From the smallest UX
                            detail to how our platform scales with your
                            business, we obsess over quality at every level.
                          </p>
                        </div>
                      </div>

                      <div className="direction-columns">
                        <div className="challenge-title">
                          <img
                            src={AboutInner}
                            alt="Simplifyte"
                            className="team-div-img"
                          />
                          <p className="team-div-img-caption mb-10">
                            Simplifyte <b> co-founders </b>Aamir Dholia & Gautam
                            Parmar.
                          </p>
                        </div>
                      </div>

                      <div className="col-12" style={{ display: "none" }}>
                        <div className="teams-div">
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Amir Dholia</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Irshad Dholia</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Irshad Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Zaid Multani</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Zaid Multani</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Harshad Bhava</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Harshad Bhava</span>
                                <span className="desg-sec">Designer</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Ronak Chauhan</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Ronak Chauhan</span>
                                <span className="desg-sec">App Developer</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Ubaid Kazi</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Ubaid Kazi</span>
                                <span className="desg-sec">App Developer</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Mahetab Saiyed</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Mahetab Saiyed</span>
                                <span className="desg-sec">
                                  Magento Developer
                                </span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Hiren Maru</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Hiren Maru</span>
                                <span className="desg-sec">
                                  Magento Developer
                                </span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Mohaammad Zaki</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Mohaammad Zaki</span>
                                <span className="desg-sec">
                                  Frontend Developer
                                </span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">
                                Mohammed Merchant
                              </p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Mohammed Merchant
                                </span>
                                <span className="desg-sec">
                                  Frontend Developer
                                </span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Manav</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Manav</span>
                                <span className="desg-sec">
                                  Laravel Developer
                                </span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Trevis Head</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Steve Smith</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Sam Constas</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Mitchel Starc</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">Pat Cummins</p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="teams-item">
                            <div className="teams-item-inner-div">
                              <img
                                src={UserAdmin}
                                alt="Simplifyte"
                                className="teams-user-img"
                              />
                              <p className="teams-user-name">
                                Marnus Labuschagne
                              </p>
                            </div>

                            <div className="team-popup">
                              <div className="img-sec">
                                <img
                                  src={UserAdmin}
                                  alt="Simplifyte"
                                  className="teams-user-img"
                                />
                              </div>
                              <div className="name-desg-sec">
                                <span className="name-sec">Amir Dholia</span>
                                <span className="desg-sec">Founder</span>
                              </div>
                              <div className="social-sec">
                                <p className="social-app-sec linkedin">
                                  <FontAwesomeIcon icon={faLinkedin} />
                                </p>
                                <p className="social-app-sec twitter">
                                  <FontAwesomeIcon icon={faTwitter} />
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <CustomFooter />
      </div>
    </>
  );
};

export default About;
